<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline pt-1 pr-1">
          Confirm Archive
          <v-spacer></v-spacer>
          <v-btn icon @click="toggle">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-1"> Are you sure you want archive this task?</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn outlined color="accent" @click="archive">Archive</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    }
  },
  methods: {
    ...mapActions({
      archiveTask: 'workOrderTask/archiveTask',
      clearTask: 'workOrderTask/clearTask',
      loadWorkOrderTasks: 'workOrderTask/getTasks'
    }),
    async archive () {
      await this.archiveTask(this.task.id)
      this.toggle()
      this.clearTask()
      this.refresh()
    },
    refresh() {
      this.searchObject.pageIndex = 1
      this.loadWorkOrderTasks(this.searchObject)
    }
  },
  computed: {
    ...mapGetters({
      task: 'workOrderTask/selectedTask',
      searchObject: 'workOrderTask/searchObject'
    })
  }
}
</script>
